import React, {Component} from "react";
import {Col, Modal, ModalBody, ModalFooter, ModalHeader, Form, FormGroup, Label, Input, Button} from "reactstrap";
import {deepCopyObject, showAxiosError} from "../../../helper/helper";
import {request} from "../../../helper/APIUtils";
import {validateField} from "../../../common/validation";
import MaskedInput from "react-text-mask";
import createIBANMask from "text-mask-addon-iban";
import Alert from "react-s-alert";

class BankModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            info: {
                bankName: "",
                iban: ""
            },
            disableSaveButton: false,
            isMounted : true
        };

        this.onChange = this.onChange.bind(this);
        this.saveClicked = this.saveClicked.bind(this);
        this.validate = this.validate.bind(this);
        this.getCustomerBankProperties = this.getCustomerBankProperties.bind(this);
    }

    componentDidMount() {
        this.getCustomerBankProperties();
    }

    getCustomerBankProperties(){
        let self = this
        let params = {
            url: `/customer/getCustomerBankProperties`,
            method: "post",
            data:{
                customerId:  (self.props.currentUser && self.props.currentUser.customerId)
            }
        };
        request(params)
            .then(function (response) {
                let customerProperties = response.data;
                if(customerProperties) {
                    self.setState({
                        info: {
                            recordId: customerProperties.recordId,
                            bankName: customerProperties.bankName,
                            iban: customerProperties.iban
                        }
                    });
                }else {
                    self.setState({info: {
                            bankName: "",
                            iban: ""
                        }});
                }
            }).catch(function (error) {
            showAxiosError(error);
        });
    }


    onChange(name, value) {
        let info = deepCopyObject(this.state.info);
        info[name] = value;
        this.setState({info});
    }

    saveClicked() {
        let self = this;
        self.setState({disableSaveButton: true});
        let error = self.validate();
        if (!error.valid) {
                Alert.error(error.message, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 2000
                });
            self.setState({disableSaveButton: false});
            return;
        } else {
            let info = deepCopyObject(this.state.info);
            if(info["recordId"] === null || info["recordId"] === undefined){
                info["recordId"] = null;
            }
            let params = {
                url: `/customer/saveCustomerBank`,
                method: 'post',
                data: info
            };
            request(params)
                .then(response => {
                    self.props.toggle();
                }).catch(error => {
                self.setState({disableSaveButton: false});
                showAxiosError(error);
            });
        }
    }

    validate() {
        let info = deepCopyObject(this.state.info);
        let error = {valid: true, message: ""};
        let value;
        for (value in info) {
            if (info[value].toString() === "undefined" || info[value].toString() === "null" || info[value].toString() === "") {
                error.valid = false;
                error.message = "<b>Devam etmek için lütfen zorunlu alanları doldurunuz.</b>";
                break;
            }
            if (value === "bankName") {
                let bankNameError = validateField("bankName", "1,45", info[value]);
                if (!bankNameError.valid) {
                    error.valid = false;
                    error.message += "<b>" + bankNameError.message + "</b>";
                }
            }
            if (value === "iban") {
                let ibanError = validateField("iban", "1,45", info[value]);
                if (!ibanError.valid) {
                    error.valid = false;
                    error.message += "<b>" + ibanError.message + "</b>";
                }
            }
        }
        return error;
    }

    render() {
        return (
            <Modal  isOpen={this.props.isOpen} size="lg">
                <ModalHeader
                    className="justify-content-center">
                    IBAN Bilgileri
                </ModalHeader>
                <ModalBody>
                    <div>
                        <Form>
                            <FormGroup row style={{textAlign: 'center'}}>
                                <Label sm={12} for="formattedName" style={{fontWeight: 'bold', fontSize: '16px'}}>SGK fatura
                                    kesmek için lütfen aşağıdaki IBAN
                                    bilgilerinizi doldurunuz.</Label>
                            </FormGroup>
                            <FormGroup row>
                                <Label sm={4} for="bankname">Şube Adı: *</Label>
                                <Col sm={8}>
                                    <Input type="text" name="bankName" value={this.state.info.bankName}
                                           onChange={(e) => this.onChange("bankName", e.target.value)}/>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label sm={4} for="iban">IBAN NO: *</Label>
                                <Col sm={8}>
                                    <MaskedInput className="form-control"
                                                 mask={createIBANMask('TR')}
                                                 placeholder={"TR__ ____ ____ ____ ____ ____ __"}
                                                 type="text"
                                                 name="iban"
                                                 value={this.state.info.iban}
                                                 onChange={(e) => this.onChange("iban", e.target.value.replace(/\s/g, ''))}/>
                                </Col>
                            </FormGroup>
                        </Form>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button style={{paddingLeft: '16px', width: '100px'}} color="secondary" onClick={()=>this.props.toggle(false)}>
                        Kapat
                    </Button>
                    <Button style={{paddingLeft: '16px', width: '100px'}} color="success" onClick={this.saveClicked}>
                        Kaydet
                    </Button>
                </ModalFooter>
            </Modal>
        )
    }
}

export default BankModal;
